import { scrollBarClassName } from '@/utils/scrollBarClassName';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { twMerge } from 'tailwind-merge';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import { StartIcon } from '../icons';
import { useTranslation } from 'react-i18next';

type CodeRunProps = {
  disabled: boolean;
  isRunning: boolean;
  onRun: () => void;
  onReset: () => void;
  output: string;
};

export default function CodeRun({
  disabled,
  isRunning,
  onRun,
  onReset,
  output,
}: CodeRunProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'codeEditor',
  });
  return (
    <div className="flex flex-col-reverse sm:flex-row w-full gap-2">
      <div className="flex sm:flex-col gap-2 shrink-0">
        <MainButton
          className="flex-row-reverse sm:w-full justify-between"
          icon={<StartIcon className="w-3" />}
          disabled={disabled || isRunning}
          loading={isRunning}
          onClick={onRun}
          text={t('run')}
        />
        <MainButton
          className="flex-row-reverse sm:w-full justify-between"
          icon={<ArrowPathIcon />}
          text={t('reset')}
          onClick={onReset}
          disabled={disabled || isRunning}
        />
      </div>
      <pre
        className={twMerge(
          'grow max-h-40 border border-neutral-content rounded-sm w-full flex p-4 text-[0.875rem] bg-base-100',
          scrollBarClassName,
        )}
      >
        {output}
      </pre>
    </div>
  );
}
